"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;
const closest = require("../helpers/traversal").closest;

class HTMLFieldSetElementImpl extends HTMLElementImpl {
  get form() {
    return closest(this, "form");
  }
}

module.exports = {
  implementation: HTMLFieldSetElementImpl
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/nodes/HTMLFieldSetElement-impl.js
// module id = v+Qt
// module chunks = 1